// src/components/Home.js
import React from "react";
import { FaArrowRight } from "react-icons/fa";
import choice from "../../assets/choose.webp";
import { Grid2, Link, Box } from "@mui/material";
import doc_ic from "../../assets/document-ic.png";
import ai_ic from "../../assets/ai-note.webp";
import taskIcon from "../../assets/task-ic.png";
import meetingIcon from "../../assets/meeting-ic.png";
import projectIcon from "../../assets/projects-lc.png";
import { blue, amber } from "@mui/material/colors";
import { useNavigate } from "react-router-dom";
import HeaderAny from "../header";
import MobileNav from "../header-mobile";
import Footer from "../footer";

const AllFeatures = () => {
  const navigate = useNavigate();

  const features = [
    {
      icon: projectIcon,
      title: "Task and Plan Management",
      ft: "plansandtasks",
      description:
        "Take control of your construction schedule with our sophisticated task and plan management system.",
      color: blue[700],
    },
    {
      icon: taskIcon,
      title: "Project Management",
      ft: "projects",
      description:
        "Transform your construction projects with our project management system designed specifically for the construction industry.",
      color: amber[600],
    },
    {
      icon: meetingIcon,
      title: "Meeting Scheduling",
      ft: "meetings",
      description:
        "Maximize the effectiveness of your project meetings with our specialized meeting management tools.",
      color: amber[600],
    },
    {
      icon: doc_ic,
      title: "Document Management",
      ft: "documents",
      description:
        "Securely store and manage your project files in one place, enabling easy access for authorized users.",
      color: blue[700],
    },
    {
      icon: projectIcon,
      title: "Inspection Scheduling & Compliance Tracking",
      ft: "",
      description:
        "Maintain quality standards and regulatory compliance with our integrated inspection and compliance tracking system. From routine quality checks to critical safety inspections, our platform helps you stay ahead of requirements while documenting every step of the process.",
      color: blue[700],
    },
    {
      icon: taskIcon,
      title: "Portfolio Management",
      ft: "",
      description:
        "Securely store and manage your project files in one place, enabling easy access for authorized users and efficient document collaboration.",
      color: amber[600],
    },
    {
      icon: meetingIcon,
      title: "Collaborative Workspace",
      ft: "",
      description:
        "Empower teams to communicate and collaborate seamlessly",
      color: amber[600],
    },
    {
      icon: doc_ic,
      title: "Smart Project Discovery",
      ft: "",
      description:
        "Explore and uncover construction projects taking place globally with our intuitive search tools.",
      color: blue[700],
    },
  ];

  return <section id="features">
    <div>
      <div className="web-only">
        <HeaderAny />
      </div>
      <div className="mobile-only">
        <MobileNav />
      </div>
    </div>
    <div className="container-top space1">
      <h1 className="h1-48-600">
        <span>ConRa's</span> Key Features to Streamline Your Workflow
      </h1>
      <p className="ft-para">
        One platform to streamline planning, coordinate teams,
        and oversee construction projects. Engineered to enhance efficiency
        and save taems valuable time
      </p>
    </div>
    {/* <div className="container-center">
    </div> */}
    <div className="grid-container space1">
      <Grid2 container rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
        {features.map((feature, index) => (
          <Grid2 key={index} size={{ xs: 12, sm: 12, md: 6 }} className="grid-item"
            onClick={() => navigate("/feature", { state: { feat: feature.ft } })}>
            <div className="feature-item">
              <div className="feature-top">
                <Box
                  sx={{
                    width: { xs: 24, sm: 30, md: 48, lg: 52 },
                    height: { xs: 24, sm: 30, md: 48, lg: 52 },
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "20px",
                    bgcolor: feature.color,
                    margin: "10px",
                    borderRadius: "20px",
                  }}
                >
                  <img
                    src={feature.icon}
                    alt="Feature icon"
                    style={{
                      maxWidth: "100%",
                      maxHeight: "100%",
                      objectFit: "contain",
                    }} />
                </Box>
                <p className="feature-item-title">
                  {feature.title}
                </p>
              </div>
              <div className="feature-content">
                <p className="feature-item-text">
                  {feature.description}
                </p>
              </div>
            </div>
          </Grid2>
        ))}
      </Grid2>
    </div>
    <Footer />
  </section>;
};
export default AllFeatures;
